import src from "IMAGE";
export default { src, width: 1486, height: 662, blurWidth: 0, blurHeight: 0};
